import { VStack, Heading, useToast, Center } from "@chakra-ui/react";
import TreasureOpportunityForm from "./Form";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../consts/routes";
import useTreasureGameOpportunities from "./hooks/useTreasureGameOpportunities";

interface TreasureOpportunityFormData {
    userId: string;
    notes?: string;
    expiresAt?: string;
    sourceType: string;
    sourceId: number;
    quantity?: number;
}

const CreateTreasureOpportunity = () => {
    const toast = useToast();
    const navigate = useNavigate();
    const { createTreasureOpportunity } = useTreasureGameOpportunities();

    const onSubmit = async (dataForm: TreasureOpportunityFormData) => {
        try {
            // Transformar los datos para enviar al backend
            const formattedData = {
                user_id: parseInt(dataForm.userId),
                notes: dataForm.notes || undefined,
                expires_at: dataForm.expiresAt || undefined,
                source_type: dataForm.sourceType,
                source_id: dataForm.sourceId,
                quantity: dataForm.quantity || 1,
            };

            await createTreasureOpportunity(formattedData);
            
            toast({
                title: 'Oportunidad Extra Creada',
                colorScheme: 'olaggPink',
                status: 'success',
                description: 'Oportunidad extra de treasure game creada con éxito',
                position: 'bottom-right',
                duration: 3000,
            });
            
            navigate(ROUTES.MINI_GAMES.treasure_opportunities.all);
        } catch (error: any) {
            console.error('Error creating treasure opportunity:', error);
            toast({
                title: 'Error',
                colorScheme: 'olaggYellow',
                status: 'error',
                description: error.message || 'Error al crear la oportunidad extra',
                position: 'bottom-right',
                duration: 3000,
            });
        }
    };

    return (
        <Center w="full" pb={4}>
            <VStack color="white" w="full" spacing={6}>
                <Heading my={2} textAlign="center">
                    Crear Oportunidad Extra
                </Heading>
                <TreasureOpportunityForm onSubmit={onSubmit} />
            </VStack>
        </Center>
    );
};

export default CreateTreasureOpportunity;
